export default __webpack_public_path__ + "static/media/landscapet.3d9995c4.jpg";